import Hero from "../components/Hero";
import WhyChooseUs from "../components/WhyChooseUs";
import ProductRange from "../components/ProductRange";
import About from "../components/About";
import Certifications from "../components/Certifications";
import FinalCTA from "../components/FinalCTA";

export default function Home() {
  return (
    <>
      <Hero />
      <WhyChooseUs />
      <ProductRange compact />
      <About />
      <Certifications />
      <FinalCTA />
    </>
  );
}
